export default __webpack_public_path__ + "static/media/BLOG_CARD_2.d0d6d0ea.png";